<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" append-to-body :close-on-click-modal="false">
    <el-form :model="form" label-width="80px" :rules="rules">
      <el-form-item label="订单号" prop="orderNo">
        <el-input v-model="form.orderNo"></el-input>
      </el-form-item>
      <el-form-item label="客户代号" prop="customerNo">
        <el-input v-model="form.customerNo"></el-input>
      </el-form-item>
      <el-form-item label="计划人" prop="planPerson">
        <el-input v-model="form.planPerson"></el-input>
      </el-form-item>
      <el-form-item label="计划时间" prop="planDate">
        <el-input v-model="form.planDate"></el-input>
      </el-form-item>
      <el-form-item label="计划时间" prop="planDate">
        <el-table :data="form.details">
          <el-table-column
              prop="modelNo"
              align="center"
              label="型号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.modelNo"></el-input>
            </template>
          </el-table-column>
          <el-table-column
              prop="className"
              align="center"
              label="产品名称">
            <template slot-scope="scope">
              <el-input v-model="scope.row.className"></el-input>
            </template>
          </el-table-column>
          <el-table-column
              prop="gyNo"
              align="center"
              label="工艺号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.gyNo"></el-input>
            </template>
          </el-table-column>
          <el-table-column
              prop="specCode"
              align="center"
              label="规格">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specCode"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {addOrders} from '@/api/storeOrders.js'

export default {
  components: {},
  props: {},
  data() {
    return {
      dialogFormVisible: false,
      form: {
        id: '',
        orderNo: '',
        customerNo: '',
        planPerson: '',
        planDate: '',
        details: [{modelNo: '', className: '', gyNo: '', specCode: '', num: '', weight: '', remarks: ''}]
      },
      title: '新增订单',
      rules: {}
    };
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form.id = ''
      this.form.name = ''
      this.form.intro = ''
      this.form.formula = ''
      this.form.itemList = []
    },
    edit(row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.title = '编辑公式'
      this.dialogFormVisible = true
    },
    init() {
      this.dialogFormVisible = true
    },
    save() {
      if (!this.form.itemList || this.form.itemList.length == 0) {
        this.$message.error('请添加公式项')
        return
      }
      if (!this.form.formula || this.form.formula.length == 0) {
        this.$message.error('请添加公式')
        return
      }
      addOrders(this.form).then(res => {
        this.$message.success('保存成功')
        this.dialogFormVisible = false
      })
    }
  }

}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.pageBox {
  display: flex;
  justify-content: flex-end;
}
</style>
